import { useQueryClient } from '@tanstack/vue-query';
import type { RouteLocationNormalized } from 'vue-router';

import { isUserOnboarded, type Profile, profileKeys } from '@/entities/profile';
import { projectKeys, projectQueryOptions } from '@/entities/project';

export async function dashboardGuard(to: RouteLocationNormalized) {
  const queryClient = useQueryClient();
  const currentProjectUuid = to.params.project_uuid as string | undefined;
  const profile = queryClient.getQueryData<Profile>(profileKeys.profile());

  if (!isUserOnboarded(profile)) {
    return {
      name: 'onboarding',
    };
  }

  if (!currentProjectUuid) {
    return;
  }

  try {
    const project = await queryClient.ensureQueryData(projectQueryOptions(currentProjectUuid));

    queryClient.setQueryData(projectKeys.project(project.uuid), project);
  } catch {
    return {
      name: '500',
    };
  }
}
